export function obfuscateEmail(email: string) {
    const splitEmail = email.split("@");
    const domain = splitEmail[1];
    const name = splitEmail[0];
    return name.substring(0, 3).concat("*******@").concat(domain);
}
